import * as React from 'react';

import { clsx } from 'clsx';
import * as styles from './QuestionsAndAnswers.css';

export const QuestionsAndAnswers = ({
  children,
  isCenteredTitle,
}: React.PropsWithChildren<{ isCenteredTitle: boolean }>): React.JSX.Element => {
  return (
    <div>
      <h2 className={clsx(styles['title'], isCenteredTitle && styles['centered-title'])}>
        У&nbsp;вас&nbsp;вопросы&nbsp;— у&nbsp;нас&nbsp;ответы
      </h2>
      <div className={styles['container']}>{children}</div>
    </div>
  );
};
